var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "warning-well" }, [
    _c("span", { attrs: { id: "validation-errors" } }, [
      _vm._v(_vm._s(_vm.$t("Validation.Title")))
    ]),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "pt-3",
        attrs: { "aria-labelledby": "validation-errors" }
      },
      _vm._l(_vm.validationErrors, function(error) {
        return _c("li", [
          _vm._v("\n      " + _vm._s(_vm.getErrorMessage(error)) + "\n    ")
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }